import { BuilderBlocks } from "@builder.io/react";
import { BuilderElement } from "@builder.io/sdk";
import { AccordionGroup } from "@faire/slate/components/accordion";
import React from "react";

import { RichText } from "../TypeParser/types";

import { BuilderAttributes } from "./BuilderTypes";
import { BuilderTypography } from "./BuilderTypography";

type Content = {
  question: string;
  answer: RichText;
};
type ContentComponent = {
  question: string;
  answer: BuilderElement[];
};

export const BuilderAccordionV2 = ({
  contents,
  contentComponents,
  attributes,
  useComponentsForItems,
  ...props
}: React.ComponentProps<typeof AccordionGroup> & {
  contents: Content[] | undefined;
  contentComponents: ContentComponent[] | undefined;
  attributes: BuilderAttributes;
  useComponentsForItems?: boolean;
}) => {
  return (
    <AccordionGroup
      {...props}
      {...attributes}
      key={attributes.key}
      builder-id={attributes["builder-id"]}
      items={
        useComponentsForItems
          ? (contentComponents?.map(
              ({ question, answer }: ContentComponent) => {
                return {
                  label: question,
                  content: <BuilderBlocks blocks={answer} />,
                };
              }
            ) ?? [])
          : (contents?.map(({ question, answer }: Content) => {
              return {
                label: question,
                content: (
                  <BuilderTypography
                    textContent={answer}
                    attributes={attributes}
                  />
                ),
              };
            }) ?? [])
      }
    />
  );
};
